import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';

const QualitySection = () => {
  const { t } = useTranslation();
  
  const materials = t('quality.materials', { returnObjects: true });

  const brandLogos = [
    {
      name: "Porcelanosa",
      url: "https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/esswdany_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-10-29%20%D0%B2%2017.15.35.png"
    },
    {
      name: "Grohe",
      url: "https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/5fb6m0qx_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-10-29%20%D0%B2%2017.15.09.png"
    },
    {
      name: "Roca",
      url: "https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/6u0hv312_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-10-29%20%D0%B2%2017.14.39.png"
    },
    {
      name: "Bosch",
      url: "https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/hnm8pjp8_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-10-29%20%D0%B2%2017.14.13.png"
    },
    {
      name: "Simon",
      url: "https://customer-assets.emergentagent.com/job_los-jardines-blanes/artifacts/0yl0h5w2_%D0%A1%D0%BD%D0%B8%D0%BC%D0%BE%D0%BA%20%D1%8D%D0%BA%D1%80%D0%B0%D0%BD%D0%B0%202025-10-29%20%D0%B2%2017.10.50.png"
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-white to-blue-50">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-[#003366] mb-4">
              {t('quality.title')}
            </h2>
            <p className="text-lg text-gray-600">
              {t('quality.subtitle')}
            </p>
          </div>

          {/* Compact Materials List */}
          <div className="bg-white rounded-xl shadow-lg p-6 mb-8">
            <div className="grid md:grid-cols-2 gap-x-8 gap-y-3">
              {materials.map((item, index) => (
                <div key={index} className="flex items-center gap-3">
                  <CheckCircle2 className="w-5 h-5 text-[#0052CC] flex-shrink-0" />
                  <span className="text-sm text-gray-700">{item}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Brand Logos */}
          <div className="text-center">
            <p className="text-sm font-semibold text-gray-600 mb-4">
              {t('quality.partnersTitle')}
            </p>
            <div className="flex flex-wrap justify-center items-center gap-8">
              {brandLogos.map((brand, index) => (
                <div 
                  key={index}
                  className="grayscale hover:grayscale-0 transition-all duration-300 opacity-70 hover:opacity-100"
                >
                  <img 
                    src={brand.url} 
                    alt={brand.name}
                    className="h-12 w-auto object-contain"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QualitySection;